import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import BuildTime from './BuildTime';
import ce from './images/ce.svg';
import eInstruction from './images/e-instruction.png';
import manufacturer from './images/manufacturer.png';
import manufacturingDate from './images/manufacturingDate.png';
import udi from './images/udi.png';

function About() {
  const { t } = useTranslation('help');
  return (
    <Fragment>
      <section id="safety">
        <h1>{t('About the service')}</h1>
        <h2>{t('Intended use')}</h2>
        <p>
          {/* This is for MDR, annex I, clause 23.4, subclause b) (...intended purpose...).*/}
          {/* This section includes the "intended target groups with clear indications". 
            Ref. 
            - CLIN-T2-PL Clinical Evaluation Plan, clause 4.1, and
            - MDR annex XIV, clause 1, 3rd bullet 
          */}
          {t('About-IntendedUseChapter1')}
        </p>
        <p>
          {t('About-IntendedUseChapter2')}
        </p>
          {/* This one and the next one are for MDR, annex I, clause 23.4, subclause b)
          (...the patient target group or groups, and of the intended users...).
          */}
        <p>
          {t('About-IntendedUseChapter3')}
        </p>
        <h2>{t('Safety information')}</h2>
        {/* This section includes the "contra-indications". 
          Ref. 
          - CLIN-T2-PL Clinical Evaluation Plan, clause 4.1, and
          - MDR annex XIV, clause 1, 3rd bullet 
        */}
        <h3>{t('Restrictions')}</h3>
        <p>
          {/* This is for R18 in RISK-T5-FM Risk Management File - Medical Issues.*/}
          {t('About-RestrictionsChapter1')}
        </p>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4, subclause w).*/}
          {t('About-RestrictionsChapter2')}
        </p>
        <p>
          {/* This is for R2 and R4 in RISK-T5-FM Risk Management File - Medical Issues.*/}
          {t('About-RestrictionsChapter3')}
        </p>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4 subclause z).*/}
          {t('About-RestrictionsChapter4')}
          {' '}
          <a href={`mailto:${t('support@sensotrend.com')}`}>{t('support@sensotrend.com')}</a>
          {' '}
          {t('About-RestrictionsChapter4End')}
        </p>
        <h3>{t('System requirements')}</h3>
        <p>
          {/* This clause is for MDR, annex I, clause 23.4, subclause ab).*/}
          {t('About-SystemRequirementsChapter1')}
          {' '}
          <a href={`mailto:${t('support@sensotrend.com')}`}>{t('support@sensotrend.com')}</a>
          {' '}
          {t('About-SystemRequirementsChapter1End')}
        </p>
        <p>
          {t('About-SystemRequirementsChapter2')}
        </p>
      </section>
      <aside id="label">
        {/* This section includes the label. 
          Ref. MDR annex XIV, clause 1, 3rd bullet, and annex I, clause 23.2.
        */}
        <h2>{t('Product information')}</h2>
        {/* This clause is for MDR, annex I, clause 23.2, subclauses a) and b).*/}
        <p>{`${t('Sensotrend Dashboard')} v.${process.env.REACT_APP_VERSION}`}</p>
        {/* This clause is for MDR, annex I, clause 23.2, subclause q).*/}
        <section id="ce">
          <figure>
            <img alt="CE" src={ce} />
          </figure>
          <p>{t('Sensotrend Dashboard is a Class I medical device')}</p>
          <p>
            {t('See the')}{' '} <a href={`${
              process.env.PUBLIC_URL
            }/DECO-T5-DC-MDD_EU_Declaration_of_Conformity_-_signed.pdf`}
           >{t('Declaration of Conformity')}</a>.
          </p>
        </section>
        {/* This clause is for EU regulation for electronic instructions (2021/2226), article 6, clause 1 and 3d.*/}
        <section id="e-instruction">
          <figure>
            <img alt={t('Electronic instruction')} src={eInstruction} />
          </figure>
          <p>
            {t('E-Instruction-Text')}
            <a href={`mailto:${t('support@sensotrend.com')}`}>{t('support@sensotrend.com')}</a>
            {t('E-Instruction-TextEnd')}
          </p>
        </section>
        <section id="device">
            {/* This clause is for MDR, annex I, clause 23.2, subclause h).*/}
          <img alt={t('Device identifier')} src={udi} />
          <p>B-FIMF000000500SD000001FS</p>
        </section>
        <section id="date">
            {/* Date of manufacture is for MDR, annex I, clause 23.2, subclause j).
              Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
            */}
          <img alt={t('Date of manufacture')} src={manufacturingDate} />
          {BuildTime}
        </section>
        <section id="manufacturer">
          <img alt={t('Manufacturer')} src={manufacturer} />
          <address>{t('Sensotrend Oy')}<br />
            {t('Tampellan esplanadi 19 A 55')}<br />
            {t('FI-33180 Tampere Finland')}<br />
            <a href={`mailto:${t('support@sensotrend.com')}`}>{t('support@sensotrend.com')}</a>
          </address>
        </section>
      </aside>
    </Fragment>
  );
}

export default About;
